import styles from './RemainingArticles.module.scss';
import React from 'react';
import {H4} from "@zooplus/ui-components";

export type RemainingArticlesProps = {
  itemsLeft: number;
};

export const RemainingArticles = (props: RemainingArticlesProps) => {


  return (
      <div className={styles.wrapper}>
        <H4 className={styles.text}>+{props.itemsLeft}</H4>
      </div>
  )
};
